import Vue from 'vue'
import './plugins/axios'
import './plugins/client'
import './plugins/logger'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import MetaInfo from 'vue-meta-info'
import MintUI from 'mint-ui'
import './assets/less/mint-ui.less'

Vue.config.productionTip = false

Vue.use(MetaInfo)
Vue.use(MintUI)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
